var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstagramCircle = function SvgInstagramCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#instagramCircle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0a9.962 9.962 0 0 1 7.067 2.933A9.962 9.962 0 0 1 20 10a9.962 9.962 0 0 1-2.933 7.067A9.962 9.962 0 0 1 10 20C4.476 20 0 15.524 0 10a9.962 9.962 0 0 1 2.933-7.067A9.962 9.962 0 0 1 10 0Zm6.248 14.324c.162-.42.276-.905.304-1.6.038-.705.048-.934.048-2.724s-.01-2.019-.048-2.724c-.028-.695-.142-1.18-.304-1.6-.172-.428-.39-.8-.762-1.162a3.075 3.075 0 0 0-1.162-.762c-.42-.162-.905-.276-1.6-.304C12.019 3.4 11.79 3.4 10 3.4s-2.019.01-2.714.048h-.01c-.695.028-1.18.142-1.6.304-.428.162-.8.39-1.162.762-.371.362-.59.734-.762 1.162-.162.42-.276.905-.304 1.6C3.41 7.981 3.4 8.21 3.4 10s.01 2.019.048 2.724c.028.695.142 1.18.304 1.6.172.428.39.8.762 1.162.362.371.734.59 1.162.762.42.162.905.276 1.6.304.705.038.934.048 2.724.048s2.019-.01 2.724-.048c.695-.028 1.18-.142 1.6-.304.428-.172.8-.39 1.162-.762.371-.362.59-.734.762-1.162Zm-1.105-8.21a2.07 2.07 0 0 0-.495-.762 2.114 2.114 0 0 0-.753-.495c-.238-.086-.59-.2-1.228-.228l-.026-.001C11.966 4.6 11.74 4.59 10 4.59c-1.762 0-1.972 0-2.667.039-.638.028-.99.142-1.219.228a2.07 2.07 0 0 0-.762.495 2.07 2.07 0 0 0-.495.762c-.086.229-.2.581-.229 1.22v.025c-.028.675-.038.9-.038 2.641 0 1.74.01 1.966.037 2.641l.002.026c.028.638.142.99.228 1.228.124.305.267.524.495.753.229.228.448.371.762.495.229.086.581.2 1.22.228l.025.002c.675.027.9.037 2.64.037 1.74 0 1.967-.01 2.642-.037l.026-.002c.638-.028.99-.142 1.228-.228.305-.124.524-.267.753-.495.228-.229.371-.448.495-.753.085-.238.2-.59.228-1.228l.001-.026c.028-.675.037-.901.037-2.641s-.009-1.966-.037-2.641v-.026c-.03-.638-.143-.99-.23-1.219ZM10 13.39A3.398 3.398 0 0 1 6.61 10 3.398 3.398 0 0 1 10 6.61 3.398 3.398 0 0 1 13.39 10 3.398 3.398 0 0 1 10 13.39Zm4.295-6.752a.76.76 0 0 1-.219.4.725.725 0 0 1-.4.22.832.832 0 0 1-.457-.048.758.758 0 0 1-.352-.296.703.703 0 0 1-.134-.438c0-.21.076-.41.229-.552a.794.794 0 0 1 .562-.238.793.793 0 0 1 .733.495.823.823 0 0 1 .038.457ZM10 12.2a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4Z",
    fill: "url(#instagramCircle_svg__b)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagramCircle_svg__b",
    x1: 3.429,
    y1: 16.571,
    x2: 16.276,
    y2: 3.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FF7A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF0069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D300C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7638FA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "instagramCircle_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#fff"
  })))));
};
export default SvgInstagramCircle;